/** 鼠标板载 profile 切换：统一事件名与 detail 结构（Menu Toast + store 同步） */

export const MOUSE_BOARD_PROFILE_CHANGED_EVENT = "mouse-board-profile-changed";

export type MouseBoardProfileChangeSource = "user" | "device" | "sync" | "auto";

export interface MouseBoardProfileChangedDetail {
  profile: number;
  name?: string;
  source?: MouseBoardProfileChangeSource;
  deviceKey?: string;
}

export function dispatchMouseBoardProfileChangedOnWindow(
  target: Window,
  detail: MouseBoardProfileChangedDetail
): void {
  if (!Number.isFinite(detail.profile)) return;
  try {
    target.dispatchEvent(
      new CustomEvent(MOUSE_BOARD_PROFILE_CHANGED_EVENT, {
        detail: {
          ...detail,
          source: detail.source ?? "user",
        },
      })
    );
  } catch {
    /* ignore */
  }
}

/** 子应用 / 同窗口：boardConfig、BoardList 等用户切换成功后调用 */
export function notifyMouseBoardProfileChanged(
  profile: number,
  opts?: Omit<MouseBoardProfileChangedDetail, "profile">
): void {
  if (typeof window === "undefined") return;
  dispatchMouseBoardProfileChangedOnWindow(window, { profile, ...opts });
}
